// يُضبط عن بُعد عبر postMessage من الـ main thread (زر محاكاة عدم الاتصال للاختبار)
let simulateOffline = false;

export function setSimulateOffline(value) {
	simulateOffline = Boolean(value);
}

function buildOfflineResponse(onFail) {
	return Promise.resolve(onFail()).then((offlineData) => {
		return new Response(
			JSON.stringify(offlineData),
			{
				headers: { 'service-worker': true }
			}
		);
	});
}

/**
 * @param {Request} request which is sent request
 * @param {Function} onSuccess has an response data as a param
 * @param {Function} onFail must return value to set response value
 */
export default function (request, onSuccess, onFail) {
	if (simulateOffline) {
		return buildOfflineResponse(onFail);
	}

	return new Promise((resolve) => {
		fetch(request)
			.then(async (response) => {
				// لا بد من انتظار onSuccess (كتابة IndexedDB) قبل resolve: الـ Promise المُعاد هنا هو
				// ما يُمرَّر لـ respondWith() في الـ fetch event، وهو ما يُبقي الـ service worker حياً
				// حتى يستقر. لو استقرت النتيجة قبل انتهاء الكتابة، يصبح المتصفح حراً في إنهاء الـ
				// service worker في أي لحظة (خصوصاً عند إغلاق التطبيق)، فتُقطَع معاملة IndexedDB في
				// منتصفها ولا تُحفَظ البيانات فعلياً - وهذا ما كان يسبب فقدان كل بيانات IDB بعد إعادة فتح
				// التطبيق رغم أنها تبدو محفوظة أثناء بقاء الجلسة مفتوحة.
				const data = await response.clone().json();
				await onSuccess(data);
				resolve(response);
			})
			.catch(async () => {
				resolve(await buildOfflineResponse(onFail));
			})
	})
}
